import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, Transition as _Transition, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-overlay"
}

import usePromoModal from '@/composables/promoModalState';
import ModalSignup from '@/components/modalSignup/modalSignup.vue';
import ModalComponent from '@/components/modalComponent/modalComponent.vue';

import { PromoPageInterface } from '@/types/promoPage.interface';


export default /*#__PURE__*/_defineComponent({
  props: {
    lang: null,
    pageData: null,
    selectedCurrency: null
  },
  emits: ["changeCurrency"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'changeCurrency', currency: string): void;
}), expose: any, slots: any, attrs: any }) {

const { show } = usePromoModal();





const emitParentEvent = (currency: string) => {
  emit('changeCurrency', currency);
}

return (_ctx: any,_cache: any) => {
  return (_unref(show))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_Transition, {
          duration: { enter: 500, leave: 200 },
          name: "globalModalAnimation"
        }, {
          default: _withCtx(() => [
            _createVNode(ModalComponent, { modal: "signup" }, {
              default: _withCtx(() => [
                _createVNode(ModalSignup, {
                  lang: __props.lang,
                  pageData: __props.pageData,
                  selectedCurrency: __props.selectedCurrency,
                  onChangeCurrency: emitParentEvent
                }, null, 8, ["lang", "pageData", "selectedCurrency"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})